<script>
	import { User } from './store.js';
	import { onDestroy } from 'svelte';
	import MultiCalendar from './components/MultiCalendar.svelte';
	import Login from './components/Login.svelte';
	import Toolbar from './components/Toolbar.svelte';
	import Footer from './components/Footer.svelte';
	const urlParams = new URLSearchParams(window.location.search);
  const isPortalsVisit = JSON.parse(urlParams.get('isPortalsVisit'));

	let user;
	const unUser = User.subscribe(v => user = v);
	onDestroy(unUser);
	//temporary migration requirement
	if(user && !user.token) User.logout();

	$: isLoggedIn = !!user && user !== 'null';
	$: isTokenActive = isPortalsVisit;

	const onLoad = el => {
		window.addEventListener('load', function() {
			var documentHeight = document.getElementById('main-element').scrollHeight;
			var message = 'documentHeight:'+documentHeight;
			parent.postMessage(message, "*");

			window.onmouseover = function(event) {
				var newDocumentHeight = document.getElementById('main-element').scrollHeight;
				var heightDiff = documentHeight - newDocumentHeight;

				if ( heightDiff > 10 | heightDiff < -10 ) {
					documentHeight = newDocumentHeight;
					message = 'documentHeight:'+documentHeight;
					parent.postMessage(message,"*");
				}
			} 

			window.onclick = function(event) {
				var newDocumentHeight = document.getElementById('main-element').scrollHeight;
				var heightDiff = documentHeight - newDocumentHeight;

				if ( heightDiff > 10 | heightDiff < -10 ) {
					documentHeight = newDocumentHeight;
					message = 'documentHeight:'+documentHeight;
					parent.postMessage(message,"*");
				}
			} 
		});
	}

</script>

<main>
	{#if !isTokenActive}
		<Toolbar user={user}/>
	{/if}

	<div class="site-content">
		{#if isLoggedIn}
		<div use:onLoad id="main-element">
			<MultiCalendar user='{user}'/>
		</div>
		{:else}
			<Login />
		{/if}
	</div>
	{#if !isTokenActive}
		<Footer />
	{/if}

</main>

<style>
main{
  display: flex;
  height: 100%;
  flex-direction: column;
}

.site-content {
  flex: 1;
  display: flex;
  flex-direction: column;
}

@media(min-width: 1440px){
/*	.site-content{
		padding:30px;
	}*/
}


</style>